import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { getCategoriesSingle, updateCategory } from "../../../../services/category";
import { useEffect, useState } from "react";
import { emptyCategory, Category } from "../../../../interfaces/category";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminCategoryEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminCategoryEdit(props: AdminCategoryEditProps) {
    const [category, setCategory] = useState<Category>(emptyCategory);

    useEffect(() => {
        getCategoriesSingle(props.id)
            .then(response => {
                setCategory(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            id: event.target.id.value,
            name: event.target.name.value,
            age_start: event.target.age_start.value,
            age_end: event.target.age_end.value
        }
        updateCategory(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }
    
    return (
        <Modal className="admin-category-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("edit_category") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { category.id == 0 && 
                    <LoadingSpinner />
                }
                { category.id != 0 && 
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Form.Group className="mb-3" controlId="id">
                                <Form.Control type="hidden" name="id" required 
                                    defaultValue={ category.id } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                <Form.Control type="text" name="name" required
                                    defaultValue={ category.name } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="age_start">
                                <Form.Label aria-required="true">{ t("age_start") }</Form.Label>
                                <Form.Control name="number" required
                                    defaultValue={ category.age_start } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="age_end">
                                <Form.Label aria-required="true">{ t("age_end") }</Form.Label>
                                <Form.Control name="number" required
                                    defaultValue={ category.age_end } />
                            </Form.Group>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
